var React = require('react');

function QuadpayBadgeInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"96","height":"96","rx":"48","fill":"#DBCCFF","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.674 54.666L31.7107 63.1106H68L66.8139 53.4407H49.8916L49.7452 52.241L65.329 41.3518L64.2878 32.8892H28L29.1876 42.5606H46.1356L46.285 43.7693L30.674 54.666Z","fill":"#1A0826","key":1})]);
}

QuadpayBadgeInline.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = QuadpayBadgeInline;

QuadpayBadgeInline.default = QuadpayBadgeInline;
